// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"219":"e5da48d3436ede1e","888":"560d518efa74997a"}[chunkId] + ".css";
};